import React, { useRef, useState } from "react";

import {
  StyleSheet,
  Text,
  View,
  TouchableOpacity,
  Dimensions,
  Image,
} from "react-native";
import { addImage } from "../utils";
import { apiservice } from "../service/api";
import { useRecoilState, useRecoilValue } from "recoil";
import { tokenState, univer, userState } from "../reducer";
import moment from "moment";
const { width, height } = Dimensions.get("window");

const homeProfile = () => {
  const token = useRecoilValue(tokenState);
  const [users, setUser] = useRecoilState(userState);
  const university = useRecoilValue(univer);

  return (
    <View style={styles.container}>
      <View style={{ width: width * 0.82, height: height * 0.9 }}>
        <View
          style={{
            width: width * 0.591,
            height: height * 0.546,
            margin: 100,
            flexDirection: "row",
          }}
        >
          <View style={{ width: width * 0.156, height: height * 0.277 }}>
            <View
              style={{
                width: width * 0.13,
                height: height * 0.231,
                backgroundColor: "#ffff",
                borderRadius: 10,
                borderWidth: 1,
                overflow: "hidden",
                borderColor: "#707070",
                justifyContent: "center",
              }}
            >
              <Image
                style={{
                  width: width * 0.13,
                  height: height * 0.231,
                  alignSelf: "center",
                  borderRadius: 10,
                }}
                source={{ uri: users.image_profile }}
              />
              <TouchableOpacity
                onPress={async () => {
                  const ree = await addImage();
                  const res = await apiservice({
                    path: "/authen/updateadmin",
                    method: "put",
                    body: {
                      ...users,
                      image_profile: ree,
                    },
                    token: token.accessToken,
                  });
                  if (res.status == 200) {
                    const res_user = await apiservice({
                      path: "/authen/getuseradmin",
                      method: "get",
                      token: token.accessToken,
                    });
                    setUser(res_user.data.result);
                  }
                }}
                style={{
                  width: 35,
                  height: 35,
                  position: "absolute",
                  right: 0,
                  marginRight: 10,
                  bottom: 0,
                  marginBottom: 10,
                }}
              >
                <Image
                  resizeMode={"cover"}
                  style={{ width: 35, height: 35, alignSelf: "center" }}
                  source={require("../img/iconCamare.png")}
                />
              </TouchableOpacity>
            </View>
          </View>
          <View
            style={{
              width: width * 0.435,
              height: height * 0.277,
              paddingLeft: 30,
            }}
          >
            <Text style={styles.Text25}>ชื่อ : {users.fullname}</Text>
            <Text style={styles.Text25}>สถานะ : {"Admin"}</Text>
            <Text style={styles.Text25}>องค์กร : {university.name}</Text>
            <Text style={styles.Text25}>โทรศัพท์ : {users.tel_number}</Text>
            <Text style={styles.Text25}>E-mail : {users.email}</Text>
            <View
              style={{
                borderWidth: 0.5,
                borderColor: "#70707050",
                width: width * 0.4,
                marginVertical: 15,
              }}
            ></View>
            <Text style={styles.Text16}>
              สร้างเมื่อวันที่ {moment(users.createdAt).format("DD/MM/YYYY")}
            </Text>
          </View>
        </View>
      </View>
    </View>
  );
};
const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#ffff",
  },
  Text25: { fontSize: 18, fontFamily: "Prompt-Regular" },
  Text16: { fontSize: 16, fontFamily: "Prompt-Regular" },
});

export default homeProfile;
